import { Action } from '@ngrx/store';
import { CtrlBaseComponent } from '../../controls';
/* ************************* CONFIG FOR CURRENT VIEW ************************* */
export enum ECurrentViewActions {
    SAVE_CURRENT_VIEW = '[CURRENT_VIEW] SAVE',
    CLEAR_CURRENT_VIEW = '[CURRENT_VIEW] CLEAR'
}

export class SaveCurrentViewAction implements Action {
    readonly type: string = ECurrentViewActions.SAVE_CURRENT_VIEW;

    constructor(public payload: any) { }
}

export class ClearCurrentViewAction implements Action {
    readonly type: string = ECurrentViewActions.CLEAR_CURRENT_VIEW;
    constructor(public payload: string = null) { }
}

export type ViewActions = SaveCurrentViewAction | ClearCurrentViewAction;

/* ************************* END CONFIG FOR CURRENT VIEW ************************* */

